import React from "react";
import PropTypes from 'prop-types';
import { useTranslator } from "@jutro/locale";
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import messages from './QuestionSetComponent.messages';

/**
 * @memberof module:gw-portals-questionsets-ui
 *
 * @property {function(newAnswers, pathToAnswers)} onValueChange - the
 *                                      function invoked when the value is changed
 * @property {function(isComponentValid, id)} onValidationChange - the
 *                                      function when validation is triggered
 * @property {string} labelPosition - the position for the question label
 * @property {string} id - the id for the component
 * @property {Object} title - the translation ready title for the question sets component
 * @property {Object} questionSetsMetadata - the question sets presentation metadata
 * @property {Object} questionSetsViewModel - the question sets view model
 *
 * @returns {ReactElement}
 */
function QuestionSetComponent({ 
    id, 
    title, 
    questionSetsMetadata, 
    questionSetsViewModel, 
    onValueChange, 
    onValidationChange, 
    labelPosition,
    showErrors,
    saveAndRender,
    isStructureTypeDisabled
 }) {
        const translator = useTranslator();
        const overrideProps = {
            '@field': {
                showOptional: false,
                showRequired: true,
                labelPosition,
                showErrors
            },
            PreQual_Gen_Above_ThirdFloor:{
                onValueChange: saveAndRender
            },
            PreQual_Prop_StructureType:{
                onValueChange: saveAndRender,
                disabled: isStructureTypeDisabled
            },
            PreQual_Prop_StructureType_TP:{
                onValueChange: saveAndRender,
                disabled: isStructureTypeDisabled
            }
        };

        if(!questionSetsMetadata){
            return null
        }

        return (
            <div>
                <h3 id={`${id}_questionSetHeader`} className='wizardPageHeader'>{translator(title)}</h3>
                <ViewModelForm
                uiProps={questionSetsMetadata}
                model={questionSetsViewModel}
                overrideProps={overrideProps}
                onValueChange={onValueChange}
                onValidationChange={onValidationChange} 
                />
            </div>
        )
    
}

QuestionSetComponent.propTypes = {
    onValueChange: PropTypes.func,
    onValidationChange: PropTypes.func,
    labelPosition: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }),
    questionSetsMetadata: PropTypes.object,
    questionSetsViewModel: PropTypes.object,
}
QuestionSetComponent.defaultProps = {
     labelPosition: 'left',
     title: messages.pageTitle
    
}
export default QuestionSetComponent;